import script from "./OrderGroupSelectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderGroupSelectModal.vue?vue&type=script&setup=true&lang=ts"

import "./OrderGroupSelectModal.vue?vue&type=style&index=0&id=85fb228c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85fb228c"]])

export default __exports__